export const E_STATEMENTS_CONTAINER_TAG_NAME = 'e-statements-container';
